import { z } from "zod";
import { RequestPartnerDtoSchema } from "./RequestPartnerDto";

export const PrepopFieldsQueryParamsSchema = RequestPartnerDtoSchema.extend({
    partnerId: z.string().nullish(),
    insuranceNumber: z.string().nullish(),
});

export type PrepopFieldsQueryParams = z.infer<typeof PrepopFieldsQueryParamsSchema>;